import {useTranslation} from "react-i18next";
import {useEffect, useState, useMemo} from "react";
import Tabs from "react-bootstrap/esm/Tabs";
import Tab from "react-bootstrap/esm/Tab";
import {useSearchParams} from "react-router-dom";

import NavBreadcrum from "components/NavBreadcrum";
import navs from "./navs";
import useCustomTranslation from "core/customTranslation";
import ViewRoutesMooch from "./route-fly/mooch/ViewRoutesMooch";
import ViewRoutesFly from "./route-fly/templates/ViewRoutesFly";
import ViewRoutes from "./route-fly/routes/ViewRoutes";

const translations = {
    es: {
        mooch: "Bolseo",
        templates: "Plantillas",
        instances: "Instancias",
    },
    en: {
        mooch: "Mooch",
        templates: "Templates",
        instances: "Instances",
    },
};

const ViewRouteFly = () => {
    const {t: _Tr} = useTranslation("routes");
    const {t: _TC} = useCustomTranslation(translations);
    const [searchParams, setSearchParams] = useSearchParams();

    document.title = _Tr("labels.routes-fly");

    const bread = useMemo(
        () => [
            {name: _Tr("labels.route-management"), url: "/route-management", current: false},
            {name: _Tr("labels.routes-fly"), current: true},
        ],
        [_Tr],
    );
    const [keyTab, setKeyTab] = useState("templates");

    useEffect(() => {
        if (searchParams.get("t")) {
            switch (searchParams.get("t")) {
                case "i":
                    setKeyTab("instances");
                    break;
                case "m":
                    setKeyTab("mooch");
                    break;
                case "t":
                    setKeyTab("templates");
                    break;
                default:
                    setKeyTab("instances");
            }
        }
    }, []);
    const onSelect = (k) => {
        setKeyTab(k);
        const tabMap = {
            instances: "i",
            mooch: "m",
            templates: "t",
        };
        setSearchParams({t: tabMap[k]});
    };

    return (
        <>
            <NavBreadcrum navs={navs} bread={bread} />
            <div className="row">
                <div className="col-md col-12 pt-3">
                    <Tabs activeKey={keyTab} id="routes-tabs" onSelect={onSelect} className="mb-3 mt-1">
                        <Tab eventKey="templates" title={_TC("templates")}>
                            <ViewRoutesFly keyTab={keyTab} setKeyTab={setKeyTab} />
                        </Tab>
                        <Tab eventKey="instances" title={_TC("instances")}>
                            <ViewRoutes keyTab={keyTab} setKeyTab={setKeyTab} />
                        </Tab>
                        <Tab eventKey="mooch" title={_TC("mooch")}>
                            <ViewRoutesMooch keyTab={keyTab} setKeyTab={setKeyTab} />
                        </Tab>
                    </Tabs>
                </div>
            </div>
        </>
    );
};

export default ViewRouteFly;
